import VueRouter from 'vue-router';
import store from "./store";

let routes=[
    {
        path: '/user/create',
        name: 'UserInfo.create',
        component: () => import( './components/UserInfo')
    },
    {
        path: '/user/edit',
        name: 'UserInfo.edit',
        component: () => import( './components/UserInfo')
    },
   // {
   //     path: '/user/edit/:id',
   //     name: 'UserInfo.edit.id',
   //     component: () => import( './components/UserInfo'),
   //     props: true
   // },
    {
        path: '/payment/',
        name: 'payment',
        component: () => import( './components/Payment'),
        props: true
    },
    {
        path: '/accessanalysis',
        name: 'accessanalysis',
        component: () => import( './components/AccessAnalysis')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import( './components/DashBoardPage')
    },
    {
        path: '/editContents/',
        name: 'Contents.edit.projectid',
        component: () => import( './components/EditQRTContents'),
        props: true
    },
    {
        path: '/editContents/',
        name: 'Contents.edit.projectid.qrcodeid',
        component: () => import( './components/EditQRTContents'),
        props: true
    },
    {
        path: '/editContents/:selectstep',
        name: 'Contents.edit.projectid.qrcodeid.selectstep',
        component: () => import( './components/EditQRTContents'),
        props: true
    },
    {
        path: '/editContentsExt/',
        name: 'ContentsExt.edit.qrcodeid',
        component: () => import( './components/EditExtQRTContents'),
        props: true
    },
    {
        path: '/editContentsExt/:selectstep',
        name: 'ContentsExt.edit.qrcodeid.selectstep',
        component: () => import( './components/EditExtQRTContents'),
        props: true
    },
    {
        path: '/editContentsExt/:selectstep/:selectlang',
        name: 'ContentsExt.edit.qrcodeid.selectstep.selectlang',
        component: () => import( './components/EditExtQRTContents'),
        props: true
    },
    {
        path: '/home',
        name: 'home',
      //  component: () => import( './components/EditExtQRTContents')
        component: () => import( './components/DashBoardPage')
    },
    {
        path: '/home/:pid',
        name: 'home',
        component: () => import( './components/DashBoardPage')
    },
    {
        path: '/admini/codelist/',
        name: 'codelist',
        component: () => import( './components/AdminCodeList')
    },
    {
        path: '/admini/userlist/',
        name: 'userlist',
        component: () => import( './components/AdminUserList')
    },
    {
        path: '/admini/loginhistory/',
        name: 'loginhistory',
        component: () => import( './components/LoginHistory')
    },
    {
        path: '/admini/accessanalysis',
        name: 'adminaccessanalysis',
        component: () => import( './components/AdminAccessAnalysis')
    },
    {
        path: '/dummypage',
        name: 'dummy',
        component: () => import( './components/DummyPage')
    },
    {
       path: '*',
       name: 'NotFound',
       component: () => import( './components/NotFound')
     }

];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});


router.beforeEach((to, from, next) => {
    // ページ遷移時にEditコード情報クリア
    store.commit('resetEdit');
    next();
});

export default router;